import IndividualCustomersService from "@/services/individualCustomersService";

import { create } from "zustand";

const useIndividualCustomerStore = create((set, get) => ({
  customers: [],
  loading: false,
  products: [],
  filters: {
    page: 1,
    size: localStorage.getItem("pageSize") || 10,
    totalPages: 0,
    totalElements: 0,
    // Search query
    query: "",
    // Name filters
    firstName: "",
    lastName: "",
    // Contact filters
    email: "",
    phone: "",
    // Date range
    createdAtStart: "",
    createdAtEnd: "",
  },
  // Sort state
  sort: [],

  getIndividuaCustomers: async () => {
    set({ loading: true });
    const state = get();

    // Build filter array for advanced API
    const filterArray = [];

    // First name filter
    if (state.filters.firstName) {
      filterArray.push({ field: "firstName", operator: "contains", value: state.filters.firstName });
    }

    // Last name filter
    if (state.filters.lastName) {
      filterArray.push({ field: "lastName", operator: "contains", value: state.filters.lastName });
    }

    // Email filter
    if (state.filters.email) {
      filterArray.push({ field: "email", operator: "contains", value: state.filters.email });
    }

    // Phone filter
    if (state.filters.phone) {
      filterArray.push({ field: "phone", operator: "contains", value: state.filters.phone });
    }

    // Date range - format: YYYY-MM-DD
    if (state.filters.createdAtStart && state.filters.createdAtEnd) {
      filterArray.push({ field: "createdAt", operator: "between", value: `${state.filters.createdAtStart}|${state.filters.createdAtEnd}` });
    } else if (state.filters.createdAtStart) {
      filterArray.push({ field: "createdAt", operator: "gte", value: state.filters.createdAtStart });
    } else if (state.filters.createdAtEnd) {
      filterArray.push({ field: "createdAt", operator: "lte", value: state.filters.createdAtEnd });
    }

    try {
      const data = await IndividualCustomersService.getIndividualCustomersAdvanced({
        page: state.filters.page,
        size: state.filters.size,
        query: state.filters.query,
        filter: filterArray,
        sort: state.sort,
      });

      set({
        customers: data.content,
        loading: false,
        meta: data.meta || null,
        filters: {
          ...state.filters,
          totalPages: data.totalPages,
          totalElements: data.totalElements,
          page: data.page,
        },
      });
    } catch (error) {
      // Fallback to old API if advanced endpoint fails
      console.warn("Advanced API failed, falling back to legacy API:", error);
      const data = await IndividualCustomersService.getIndividualCustomers(state.filters);
      set({
        customers: data.content,
        loading: false,
        filters: {
          ...state.filters,
          totalPages: data.totalPages,
          page: data.page,
        },
      });
    }
  },

  setFilters: (filters) => {
    set({ filters });
  },

  // Sort functions
  setSort: (sortArray) => {
    set({ sort: sortArray });
  },

  toggleSort: (field) => {
    const state = get();
    const existingSort = state.sort.find((s) => s.field === field);

    let newSort;
    if (!existingSort) {
      newSort = [{ field, direction: "ASC" }];
    } else if (existingSort.direction === "ASC") {
      newSort = [{ field, direction: "DESC" }];
    } else {
      newSort = [];
    }

    set({ sort: newSort });
    get().getIndividuaCustomers();
  },

  clearSort: () => {
    set({ sort: [] });
    get().getIndividuaCustomers();
  },

  clearAllFilters: () => {
    set({
      filters: {
        page: 1,
        size: localStorage.getItem("pageSize") || 10,
        totalPages: 0,
        totalElements: 0,
        query: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        createdAtStart: "",
        createdAtEnd: "",
      },
      sort: [],
    });
    get().getIndividuaCustomers();
  },
}));

export default useIndividualCustomerStore;
